/**
 * FilterChip
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Icon } from 'ui-component-library/base';
import ButtonSupportive from '../ButtonSupportive';
/** A filter chip to use for listing filters */
var FilterChip = function (_a) {
    var children = _a.children, onClick = _a.onClick, _b = _a.type, type = _b === void 0 ? 'button' : _b, className = _a.className, htmlAttributes = __rest(_a, ["children", "onClick", "type", "className"]);
    return (React.createElement(ButtonSupportive, __assign({ type: type, variant: "squared", className: className, onClick: onClick }, htmlAttributes),
        children,
        React.createElement(Icon, { icon: "close", className: "ml-2", "aria-hidden": true })));
};
export default FilterChip;
